import { useState, useEffect } from "react";
import useGenres from "../../Components/Hooks/useGenre";
import axios from "axios";
import Genres from "../../Components/Genres";
import SingleContent from "../../Components/SingleContent/SingleContent";
import CustomPagination from "../../Components/Pagination/CustomPagination";


const Series = () => {
    const [page ,setPage] = useState(1);
    const [content , setContent] = useState([]);
    const [numOfPages , setNumOfPages] = useState();
    const [selectedGenres , setSelectedGenres] = useState([]);
    const [genres , setGenres] = useState([]);
    const genresforURL = useGenres(selectedGenres)

    const fetchMovies = async () =>{
        const {data} = await axios.get(`https://api.themoviedb.org/3/discover/tv?api_key=2c629ca30095712591ced9ffe3cd649c&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}&with_genres=${genresforURL}`)
    
      setContent(data.results);
      setNumOfPages(data.total_pages)

    }

    
    useEffect(() =>{
        fetchMovies()
         // eslint-disable-next-line 
       }, [page,genresforURL]);
       


    return (
        <div>
             <span className = 'pageTitle'>Tv Series</span>

             <Genres
        type="tv"
        selectedGenres={selectedGenres}
        setSelectedGenres={setSelectedGenres}
        genres={genres}
        setGenres={setGenres}
        setPage={setPage}
      />
             <div className="trending">
        {content &&
          content.map((c) => (
            <SingleContent
              key={c.id}
              id={c.id}
              poster={c.poster_path}
              title={c.title || c.name}
              date={c.first_air_date || c.release_date}
              media_type="tv"
              vote_average={c.vote_average}
            />
          ))}
      </div>
      {numOfPages > 1 && (
        <CustomPagination setPage={setPage} numOfPages={numOfPages} />
      )}
        </div>
    )
}

export default Series
